import Link from "next/link";
import React from "react";
import styled from "styled-components";
import Image from "~/components/atoms/Image";
import Twemoji from "~/components/atoms/Twemoji";
import { breakPoint, colorPrimary } from "~/lib/constants";
import { pagesPath, staticPath } from "faqSrc/lib/$path";

interface Props {
  className?: string;
}

const GameWriterWantedBanner: React.VFC<Props> = ({ className }) => {
  return (
    <Link href={pagesPath.recruitment.game_writer.$url()} passHref>
      <BannerLink>
        <Container className={className}>
          <DescriptionWrapper>
            <Text>
              <Highlight>ゲームが最高に楽しくなる</Highlight>
              <br />
              コンテンツを一緒に作ろう！
            </Text>
            <Image
              src={staticPath.img.online_game_svg}
              alt="online game"
              layout="responsive"
              ampLayout="responsive"
              width={64}
              height={52}
            />
          </DescriptionWrapper>
          <Button className="btn-gradient">
            <ButtonText>
              ゲームライター募集中
              <EmojiWrapper>
                <Twemoji src={staticPath.img.emoji.$1f601_svg} alt="😁" />
              </EmojiWrapper>
            </ButtonText>
          </Button>
        </Container>
      </BannerLink>
    </Link>
  );
};

const DescriptionWrapper = styled.div`
  align-items: center;
  display: grid;
  gap: 16px;
  grid-template-columns: auto 64px;
`;

const Text = styled.p`
  font-weight: bold;
  font-size: 20px;
  line-height: 32px;
  text-align: left;

  @media only screen and (max-width: 430px) {
    font-size: 18px;
  }

  @media only screen and (max-width: ${breakPoint["xs"]}) {
    font-size: 16px;
  }
`;

const Highlight = styled.span`
  color: var(--pri-clr600);
`;

const Container = styled.section`
  background: var(--body-bg-clr);
  display: grid;
  gap: 24px;
  justify-content: center;
  padding: 32px 20px;
  border: solid 5px var(--box-bdr-clr);
  border-radius: 10px;

  &:hover {
    background: var(--hv-box-bg-clr);

    & ${Text} {
      text-decoration: underline var(--body-clr);
    }
    & ${Highlight} {
      text-decoration: underline ${colorPrimary[600]};
    }
  }
`;

const Button = styled.div`
  color: #fff;
  border-radius: 5px;
  display: grid;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  min-height: 52px;
  padding: 12px 20px;
  width: 100%;

  @media only screen and (max-width: ${breakPoint["xs"]}) {
    font-size: 16px;
  }
`;

const ButtonText = styled.div`
  display: grid;
  grid-template-columns: 1fr 24px;
  gap: 6px;
  align-items: center;
  margin: auto;
`;

const EmojiWrapper = styled.span`
  font-size: 22px;
`;

const BannerLink = styled.a`
  color: var(--body-clr);
  &:visited {
    color: unset;
  }
`;

export default GameWriterWantedBanner;
